export const normalizeAssetPath = (
  assetUrl,
  origin = typeof window !== "undefined" ? window.location.origin : "http://localhost",
) => {
  if (!assetUrl) {
    return null;
  }

  try {
    return new URL(assetUrl, origin).pathname;
  } catch (error) {
    return null;
  }
};

export const getCurrentMainAssetPath = (
  doc = typeof document !== "undefined" ? document : null,
  origin = typeof window !== "undefined" ? window.location.origin : "http://localhost",
) => {
  if (!doc?.querySelector) {
    return null;
  }

  const mainScript = doc.querySelector('script[src*="/static/js/main."]');

  return normalizeAssetPath(mainScript?.src, origin);
};

export const getManifestMainAssetPath = (
  manifest,
  origin = typeof window !== "undefined" ? window.location.origin : "http://localhost",
) => normalizeAssetPath(manifest?.files?.["main.js"], origin);

export const getManifestBuildIdentifier = (
  manifest,
  origin = typeof window !== "undefined" ? window.location.origin : "http://localhost",
) => getManifestMainAssetPath(manifest, origin);
